import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import Store from '@ember-data/store';
import SelectLocations from 'bcl/components/input/select-locations';
import PageSetup from 'bcl/components/page-setup';
import type LocationModel from 'bcl/models/location';
import { pageTitle } from 'ember-page-title';
import type LocationItemModel from 'bcl/models/location-item';
import { Input } from '@ember/component';
import { on } from '@ember/modifier';
import not from 'ember-truth-helpers/helpers/not';
import or from 'ember-truth-helpers/helpers/or';
import { fn } from '@ember/helper';
import type NotificationService from 'bcl/services/notification';

interface ProposedSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}
export default class ViewsProposedRoute extends Component<ProposedSignature> {
  @service declare store: Store;
  @service declare notification: NotificationService;

  @tracked showAll = false;

  get items() {
    const all = this.store.peekAll<LocationItemModel>('location-item');
    // console.log(all);
    const filtered = all
      .filter((i) => i.location == this.location)
      .filter((i) => this.showAll || i.proposal_amount);
    return filtered.sort((a, b) => a.item.name.localeCompare(b.item.name));
  }
  @action toggleShowAll() {
    this.showAll = !this.showAll;
  }
  @tracked location?: LocationModel;
  @action changeLocation(location: LocationModel | null) {
    this.location = location ? location : undefined;
  }
  @action async saveFor(li: LocationItemModel) {
    await li.save();
    this.notification.success('Erfolgreich gespeichert!');
  }
  <template>
    {{pageTitle "Standardwerte"}}
    <PageSetup @title="Standardwerte">

      <SelectLocations
        @label="Ort"
        @name="location"
        @onChange={{this.changeLocation}}
        @value={{this.location}}
      />
      <div class="mt-8 flow-root">
        <button
          {{on "click" this.toggleShowAll}}
          type="button"
          class="inline-block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >{{#if this.showAll}}Nicht mehr alle{{else}}Alle{{/if}}
          anzeigen</button>
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle">
            <table
              class="relative min-w-full divide-y divide-gray-300 dark:divide-white/15"
            >
              <thead>
                <tr>
                  <th
                    scope="col"
                    class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900 sm:pl-6 lg:pl-8 dark:text-white"
                  >Name</th>
                  <th
                    scope="col"
                    class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white"
                  >Menge</th>
                  <th scope="col" class="py-3.5 pr-4 pl-3 sm:pr-6 lg:pr-8">
                    <span class="sr-only">save</span>
                  </th>
                </tr>
              </thead>
              <tbody
                class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900"
              >
                {{#each this.items as |li|}}
                  <tr>
                    <td
                      class="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6 lg:pl-8 dark:text-white"
                    >{{li.item.name}}</td>
                    <td
                      class="px-3 py-4 text-sm whitespace-nowrap text-gray-500 dark:text-gray-400"
                    >
                      <Input @value={{li.virtual_proposal_amount}} />
                    </td>

                    <td
                      class="py-4 pr-4 pl-3 text-right text-sm font-medium whitespace-nowrap sm:pr-6 lg:pr-8"
                    >
                      <button
                        {{on "click" (fn this.saveFor li)}}
                        disabled={{or (not li.hasDirtyAttributes) li.isSaving}}
                        class="text-indigo-600 enabled:hover:text-indigo-900 disabled:cursor-not-allowed disabled:text-gray-400 dark:text-indigo-400 dark:enabled:hover:text-indigo-300 dark:disabled:text-gray-600"
                      >speichern</button>
                    </td>
                  </tr>
                {{/each}}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </PageSetup>
  </template>
}
